import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, Transition as _Transition, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { ref, onMounted, nextTick } from 'vue';

export default /*@__PURE__*/_defineComponent({
  __name: 'shrink',
  setup(__props) {

/*
 * @author: Lew
 * @e-mail: yaol@jiguang.cn
 * @date: 2022/08/24 15:01:24
 * @description: 伸展-收缩动画
 */
const slotRef = ref();
const handleNodeBeforeEnter = (el: HTMLDivElement) => {
  el.style.height = '0px';
  el.style.opacity = '0';
};
const handleNodeEnter = (el: HTMLDivElement) => {
  nextTick(() => {
    el.style.height = `${el.scrollHeight}px`;
    el.style.opacity = '1';
  });
};
const handleNodeAfterEnter = (el: HTMLDivElement) => {
  el.setAttribute('style', '');
};
const handleNodeBeforeLeave = (el: HTMLDivElement) => {
  nextTick(() => {
    el.style.height = `${el.scrollHeight}px`;
    el.style.opacity = '1';
  });
};

const handleNodeLeave = (el: HTMLDivElement) => {
  setTimeout(() => {
    el.style.height = '0px';
    el.style.opacity = '0';
  });
};

onMounted(() => {
  slotRef.value.classList?.add('pre-transition-shrink');
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_Transition, {
    ref_key: "slotRef",
    ref: slotRef,
    name: "slide-fade",
    onBeforeEnter: handleNodeBeforeEnter,
    onEnter: handleNodeEnter,
    onAfterEnter: handleNodeAfterEnter,
    onBeforeLeave: handleNodeBeforeLeave,
    onLeave: handleNodeLeave
  }, {
    default: _withCtx(() => [
      _renderSlot(_ctx.$slots, "default")
    ]),
    _: 3
  }, 512))
}
}

})